import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook para verificar alarmas de combos
 * Revisa cada minuto si hay una alarma que deba sonar
 */
const useAlarmChecker = () => {
  const navigate = useNavigate();

  const checkAlarms = useCallback(() => {
    const now = new Date();
    const currentTime = now.toTimeString().slice(0, 5); // "HH:MM"
    const currentDay = ['dom', 'lun', 'mar', 'mie', 'jue', 'vie', 'sab'][now.getDay()];
    
    const alarms = JSON.parse(localStorage.getItem('audioyou_alarms') || '{}');
    
    for (const [comboId, alarm] of Object.entries(alarms)) {
      if (alarm.time === currentTime) {
        // Verificar si es el día correcto (o si no tiene días específicos)
        if (alarm.days.length === 0 || alarm.days.includes(currentDay)) {
          // Verificar que no hayamos disparado esta alarma ya hoy
          const lastTriggered = localStorage.getItem(`alarm_triggered_${comboId}`);
          const today = now.toDateString();
          
          if (lastTriggered !== today) {
            // Marcar como disparada hoy
            localStorage.setItem(`alarm_triggered_${comboId}`, today);
            
            // Notificar al usuario
            if ('Notification' in window && Notification.permission === 'granted') {
              new Notification('⏰ AudioToo Alarma', {
                body: `Es hora de escuchar: ${alarm.name}`,
                icon: '/logo192.png',
                tag: `alarm-${comboId}`
              });
            }
            
            // Mostrar alerta y navegar
            const shouldPlay = window.confirm(`⏰ ¡Alarma!\n\nEs hora de escuchar: "${alarm.name}"\n\n¿Reproducir ahora?`);
            if (shouldPlay) {
              navigate(`/combos?play=${comboId}`);
            }
          }
        }
      }
    }
  }, [navigate]);

  useEffect(() => {
    // Pedir permiso de notificaciones si no lo tenemos
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    // Verificar inmediatamente al montar
    checkAlarms();
    
    // Verificar cada 30 segundos
    const interval = setInterval(checkAlarms, 30000);
    
    return () => clearInterval(interval);
  }, [checkAlarms]);
};

export default useAlarmChecker;
